// extracted by mini-css-extract-plugin
export const sectionRoot = "styles-module--sectionRoot--Qkfrf";
export const txtSubTitle = "styles-module--txtSubTitle--USICt";
export const btnPromote = "styles-module--btnPromote--HqVTh";